import { saveAs } from 'file-saver';

import {MDCRipple} from '@material/ripple';

const fabRipple = new MDCRipple(document.querySelector('.mdc-fab'));
const buttonRipple = new MDCRipple(document.querySelector('.mdc-button'));

function hasGetUserMedia() {
  return !!(navigator.mediaDevices &&
    navigator.mediaDevices.getUserMedia);
}

if (hasGetUserMedia()) {
  // Good to go!
} else {
  alert('getUserMedia() is not supported by your browser');
}

// let selectedCamera = 0;
let currentFacingMode = "environment";

const constraints = {
  video: {
    width: {min: 1280},
    height: {min: 720},
    facingMode: currentFacingMode,
  }
};

const frontPage = document.querySelector('.front-page');
const startButton = document.querySelector('.front-page .start-button');
const video = document.querySelector('video');
const flipButton = document.querySelector('.main .camera-flip');
const photoButton = document.querySelector('.main .screenshot-button');
const deleteButton = document.querySelector('.main .delete-button');
const saveButton = document.querySelector('.main .save-button');
const idField = document.querySelector('.main .id-field');
const objectId = document.querySelector('.main .id-field #object-id');
const mainPage = document.querySelector('.main');
const imgContainer = document.querySelector('.main .img-container');



let videoDevices = null;
let pos = null;
let touchDevice = false;
let topLeft = null;
let topRight = null;
let bottomLeft = null;
let bottomRight = null;
let touchRadius = null;

navigator.mediaDevices.enumerateDevices().
then(function(devices) {
  videoDevices = devices.filter(device => device.kind === 'videoinput');
  if (videoDevices.length > 0) {
    flipButton.hidden = false;
  }
})

let canvas = document.getElementById('canvas'),
  ctx = canvas.getContext('2d'),
  rect = null,
  dragCorner = false,
  dragSide = false;

function init() {
  navigator.mediaDevices.getUserMedia(constraints).
  then((stream) => {video.srcObject = stream});

  navigator.mediaDevices.enumerateDevices().
  then(function(devices) {
    videoDevices = devices.filter(device => device.kind === 'videoinput');
    if (videoDevices.length > 0) {
      flipButton.hidden = false;
    }
  })

  canvas.addEventListener('mousedown', mouseDown, false);
  canvas.addEventListener('mouseup', mouseUp, false);
  canvas.addEventListener('mousemove', mouseMove, false);

  canvas.addEventListener('touchstart', touchDown, false);
  canvas.addEventListener('touchend', touchUp, false);
  canvas.addEventListener('touchmove', touchMove, false);
}

function getDist(p1, p2) {
  return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
}

function closeToHandle(rect, pos) {
  let ret = null;
  if (rect === null) {
    return ret;
  }
  let maxDist = touchRadius * pos.scale;
  let currMinDist = null;
  let closestIndex = null;
  let corners = [
    {x: rect.startX, y: rect.startY},
    {x: rect.startX + rect.w, y: rect.startY},
    {x: rect.startX + rect.w, y: rect.startY + rect.h},
    {x: rect.startX, y: rect.startY + rect.h},
  ]
  let sides = [
    {x: rect.startX +  rect.w/2, y: rect.startY},
    {x: rect.startX + rect.w, y: rect.startY + rect.h/2},
    {x: rect.startX + rect.w/2, y: rect.startY + rect.h},
    {x: rect.startX, y: rect.startY + rect.h/2},
  ];

  for (let i = 0; i<4; i++){
    let dist = getDist(pos, corners[i]);
    if (currMinDist === null || dist < currMinDist){
      currMinDist = dist;
      closestIndex = i;
    }
  }
  if (currMinDist <= maxDist){
    ret = {
      corner: true,
      x: corners[closestIndex].x,
      y: corners[closestIndex].y,
      opposite: {
        x: corners[(closestIndex + 2) % 4].x,
        y: corners[(closestIndex + 2) % 4].y,
      }
    };
  }else{
    for (let i = 0; i<4; i++){
      let dist = getDist(pos, sides[i]);
      if (currMinDist === null || dist < currMinDist){
        currMinDist = dist;
        closestIndex = i;
      }
    }
    if (currMinDist <= maxDist){
      rect = {
        startX: Math.min(rect.startX, rect.startX + rect.w),
        startY: Math.min(rect.startY, rect.startY + rect.h),
        h: Math.abs(rect.h),
        w: Math.abs(rect.w),
      }

      ret = {
        corner: false,
        index: closestIndex,
        opposite: {
          x: corners[(closestIndex + 2) % 4].x,
          y: corners[(closestIndex + 2) % 4].y,
        }
      }
    }
  }
  return ret;
}

function mouseDown(e) {
  touchDevice = false;
  pos = getMousePos(canvas, e);

  let closeHandle = closeToHandle(rect, pos);
  if (closeHandle !== null){
    if (closeHandle.corner) {
      rect = {};
      rect.startX = closeHandle.opposite.x;
      rect.startY = closeHandle.opposite.y;
      rect.w = pos.x - rect.startX;
      rect.h = pos.y - rect.startY;
      dragCorner = true;
    }else{
      if (closeHandle.index === 0) {
        rect.h += rect.startY - pos.y;
        rect.startY = pos.y;
      } else if (closeHandle.index === 3) {
        rect.w += rect.startX - pos.x;
        rect.startX = pos.x;
      }else if (closeHandle.index === 1) {
        rect.w = pos.x - rect.startX;
      } else if (closeHandle.index === 2) {
        rect.h = pos.y - rect.startY;
      }
      dragSide = closeHandle.index;
    }


    ga('send', {
      hitType: 'event',
      eventCategory: 'Annotation',
      eventAction: 'edit annotation',
      eventLabel: 'Reddit Campaign'
    });
  }else {
    rect = {};
    rect.startX = pos.x;
    rect.startY = pos.y;
    rect.w = 0;
    rect.h = 0;
    dragCorner = true;

    ga('send', {
      hitType: 'event',
      eventCategory: 'Annotation',
      eventAction: 'create annotation',
      eventLabel: 'Reddit Campaign'
    });
  }
}

function mouseUp() {
  dragCorner = false;
  dragSide = false;
  ctx.clearRect(0,0,canvas.width,canvas.height);
  draw(pos.scale)
}

function mouseMove(e) {
  pos = getMousePos(canvas, e);
  let closeHandle = closeToHandle(rect, pos);
  if (closeHandle !== null){
    canvas.style.cursor = "pointer";
  }else{
    canvas.style.cursor = "default";
  }

  if (dragCorner) {
    rect.w = pos.x - rect.startX;
    rect.h = pos.y - rect.startY ;
    ctx.clearRect(0,0,canvas.width,canvas.height);
    draw(pos.scale);
  } else if (dragSide !== false) {
    if (dragSide === 0) {
      rect.h += rect.startY - pos.y;
      rect.startY = pos.y;
    } else if (dragSide === 3) {
      rect.w += rect.startX - pos.x;
      rect.startX = pos.x;
    }else if (dragSide === 1) {
      rect.w = pos.x - rect.startX;
    } else if (dragSide === 2) {
      rect.h = pos.y - rect.startY;
    }
    draw(pos.scale);
  }
}

function touchDown(e) {
  touchDevice = true;
  pos = getTouchPos(canvas, e);

  let closeHandle = closeToHandle(rect, pos);
  if (closeHandle !== null){
    if (closeHandle.corner) {
      rect = {};
      rect.startX = closeHandle.opposite.x;
      rect.startY = closeHandle.opposite.y;
      rect.w = pos.x - rect.startX;
      rect.h = pos.y - rect.startY ;
      dragCorner = true;
    } else {
      if (closeHandle.index === 0) {
        rect.h += rect.startY - pos.y;
        rect.startY = pos.y;
      } else if (closeHandle.index === 3) {
        rect.w += rect.startX - pos.x;
        rect.startX = pos.x;
      }else if (closeHandle.index === 1) {
        rect.w = pos.x - rect.startX;
      } else if (closeHandle.index === 2) {
        rect.h = pos.y - rect.startY;
      }
      dragSide = closeHandle.index;
    }
  } else {
    rect = {};
    rect.startX = pos.x;
    rect.startY = pos.y;
    rect.w = 0;
    rect.h = 0;
    dragCorner = true;
  }
}

function touchUp() {
  dragCorner = false;
  dragSide = false;
  ctx.clearRect(0,0,canvas.width,canvas.height);
  draw(pos.scale)
}

function touchMove(e) {
  pos = getTouchPos(canvas, e);

  if (dragCorner) {
    rect.w = pos.x - rect.startX;
    rect.h = pos.y - rect.startY ;
    ctx.clearRect(0,0,canvas.width,canvas.height);
    draw(pos.scale);
  } else if (dragSide !== false) {
    if (dragSide === 0) {
      rect.h += rect.startY - pos.y;
      rect.startY = pos.y;
    } else if (dragSide === 3) {
      rect.w += rect.startX - pos.x;
      rect.startX = pos.x;
    }else if (dragSide === 1) {
      rect.w = pos.x - rect.startX;
    } else if (dragSide === 2) {
      rect.h = pos.y - rect.startY;
    }
    draw(pos.scale);
  }
}

function draw(scale) {
  ctx.drawImage(video, 0, 0);
  ctx.lineWidth = 0;
  ctx.fillStyle = "rgba(198, 40, 40, 0.25)";

  ctx.fillRect(
    0,
    0,
    Math.min(rect.startX, rect.startX + rect.w),
    canvas.height
  )
  ctx.fillRect(
    Math.max(rect.startX, rect.startX + rect.w),
    0,
    canvas.width - Math.max(rect.startX, rect.startX + rect.w),
    canvas.height
  )
  ctx.fillRect(
    Math.min(rect.startX, rect.startX + rect.w),
    0,
    Math.abs(rect.w),
    Math.min(rect.startY, rect.startY + rect.h)
  )
  ctx.fillRect(
    Math.min(rect.startX, rect.startX + rect.w),
    Math.max(rect.startY, rect.startY + rect.h),
    Math.abs(rect.w),
    canvas.height - Math.max(rect.startY, rect.startY + rect.h)
  )

  ctx.lineWidth = 2 * scale;
  ctx.strokeStyle = "rgba(183, 28, 28, 0.6)";   // "#B71C1C";
  // ctx.setLineDash([6 * scale]);
  ctx.strokeRect(rect.startX, rect.startY, rect.w, rect.h);

  let dotRadius = 6 * scale;
  touchRadius = 6 * 5 * scale;

  ctx.beginPath();

  topLeft = {
    'x': Math.min(rect.startX, rect.startX + rect.w),
    'y': Math.min(rect.startY, rect.startY + rect.h)
  }
  topRight = {
    'x': Math.max(rect.startX, rect.startX + rect.w),
    'y': Math.min(rect.startY, rect.startY + rect.h)
  }
  bottomLeft = {
    'x': Math.min(rect.startX, rect.startX + rect.w),
    'y': Math.max(rect.startY, rect.startY + rect.h)
  }
  bottomRight = {
    'x': Math.max(rect.startX, rect.startX + rect.w),
    'y': Math.max(rect.startY, rect.startY + rect.h)
  }


  // draw inner corner dots
  ctx.beginPath();
  ctx.arc(topLeft.x, topLeft.y, dotRadius,0.5 * Math.PI, 2.0 * Math.PI,false);
  ctx.lineTo(topLeft.x, topLeft.y);
  ctx.fillStyle = "rgba(183, 28, 28, 0.8)";
  ctx.fill();

  ctx.beginPath();
  ctx.arc(topRight.x, topRight.y, dotRadius, Math.PI, 0.5 * Math.PI,false);
  ctx.lineTo(topRight.x, topRight.y);
  ctx.fillStyle = "rgba(183, 28, 28, 0.8)";
  ctx.fill();

  ctx.beginPath();
  ctx.arc(bottomLeft.x, bottomLeft.y, dotRadius,0.0, 1.5 * Math.PI,false);
  ctx.lineTo(bottomLeft.x, bottomLeft.y);
  ctx.fillStyle = "rgba(183, 28, 28, 0.8)";
  ctx.fill();

  ctx.beginPath();
  ctx.arc(bottomRight.x, bottomRight.y, dotRadius,1.5 * Math.PI, Math.PI,false);
  ctx.lineTo(bottomRight.x, bottomRight.y);
  ctx.fillStyle = "rgba(183, 28, 28, 0.8)";
  ctx.fill();


  //draw smaller side dots
  ctx.beginPath();
  ctx.arc((topLeft.x + topRight.x) / 2, topLeft.y, dotRadius,Math.PI, 2.0 * Math.PI,false);
  ctx.lineTo((topLeft.x + topRight.x) / 2, topLeft.y);
  ctx.fillStyle = "rgba(183, 28, 28, 0.8)";
  ctx.fill();

  ctx.beginPath();
  ctx.arc(topRight.x, (topRight.y + bottomRight.y) / 2, dotRadius, 1.5 *Math.PI, 0.5 * Math.PI,false);
  ctx.lineTo(topRight.x, (topRight.y + bottomRight.y) / 2);
  ctx.fillStyle = "rgba(183, 28, 28, 0.8)";
  ctx.fill();

  ctx.beginPath();
  ctx.arc(bottomLeft.x, (bottomLeft.y + topLeft.y) / 2, dotRadius,0.5 * Math.PI, 1.5 * Math.PI,false);
  ctx.lineTo(bottomLeft.x, (bottomLeft.y + topLeft.y) / 2);
  ctx.fillStyle = "rgba(183, 28, 28, 0.8)";
  ctx.fill();

  ctx.beginPath();
  ctx.arc((bottomLeft.x + bottomRight.x) / 2, bottomRight.y, dotRadius,0.0, Math.PI,false);
  ctx.lineTo((bottomLeft.x + bottomRight.x) / 2, bottomRight.y);
  ctx.fillStyle = "rgba(183, 28, 28, 0.8)";
  ctx.fill();
}

function getContainedSize(canvas) {
  let bcrect = canvas.getBoundingClientRect();
  let ratio = canvas.width/canvas.height,
    width = bcrect.height*ratio,
    height = bcrect.height;
  if (width > bcrect.width) {
    width = bcrect.width
    height = bcrect.width/ratio
  }
  return {width: width, height: height}
}

function getOffsetLeft( elem )
{
    let offsetLeft = 0;
    do {
      if ( !isNaN( elem.offsetLeft ) )
      {
          offsetLeft += elem.offsetLeft;
      }
    } while( elem = elem.offsetParent );
    return offsetLeft;
}

function getMousePos(canvas, evt) {
  let containedSize = getContainedSize(canvas);
  let bcrect = canvas.getBoundingClientRect(); // abs. size of element
  let scaleX = canvas.width / containedSize.width;    // relationship bitmap vs. element for X
  let scaleY = canvas.height / containedSize.height;  // relationship bitmap vs. element for Y


  return {
    x: (evt.clientX - (bcrect.width - containedSize.width) / 2) * scaleX,   // scale mouse coordinates after they have
    y: (evt.clientY) * scaleY,     // been adjusted to be relative to element
    scale: scaleX,
  }
}

function  getTouchPos(canvas, evt) {
  let containedSize = getContainedSize(canvas);
  let bcrect = canvas.getBoundingClientRect(); // abs. size of element
  let scaleX = canvas.width / containedSize.width;    // relationship bitmap vs. element for X
  let scaleY = canvas.height / containedSize.height;  // relationship bitmap vs. element for Y
  let touchLocation = evt.targetTouches[0];

  return {
    x: (touchLocation.pageX - (bcrect.width - containedSize.width) / 2) * scaleX,   // scale mouse coordinates after they have
    y: (touchLocation.pageY) * scaleY,     // been adjusted to be relative to element
    scale: scaleX,
  }
}

function zeroPadFront(string, digits){
  return "0".repeat(digits - string.length) + string.toString()
}

function getDateTimeSting() {
  let today = new Date();
  let date = today.getFullYear() +
    zeroPadFront(today.getMonth()+1, 2) +
    zeroPadFront(today.getDate(), 2);
  let time = zeroPadFront(today.getHours(), 2) +
    zeroPadFront(today.getMinutes(), 2 ) +
    zeroPadFront(today.getSeconds(), 2);
  return "_" + date + "_" + time;
}

function OBJtoXML(obj) {
  var xml = '';
  for (var prop in obj) {
    xml += obj[prop] instanceof Array ? '' : "<" + prop + ">";
    if (obj[prop] instanceof Array) {
      for (var array in obj[prop]) {
        xml += "<" + prop + ">";
        xml += OBJtoXML(new Object(obj[prop][array]));
        xml += "</" + prop + ">";
      }
    } else if (typeof obj[prop] == "object") {
      xml += OBJtoXML(new Object(obj[prop]));
    } else {
      xml += obj[prop];
    }
    xml += obj[prop] instanceof Array ? '' : "</" + prop + ">";
  }
  var xml = xml.replace(/<\/?[0-9]{1,}>/g, '');
  return xml
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

startButton.onclick = function() {
  frontPage.hidden = true;
  mainPage.hidden = false;
  init()
};

flipButton.onclick = function(){
  // we need to flip, stop everything
  video.srcObject.getTracks().forEach(function(track) {
    track.stop();
  });
  video.pause()
  video.srcObject = null
  // selectedCamera = (selectedCamera + 1) % (videoDevices.length)
  if (currentFacingMode === "environment"){
    currentFacingMode = "user"
  }else{
    currentFacingMode = "environment"
  }

  const updatedConstraints = {
    video: {
      width: {min: 1280},
      height: {min: 720},
      facingMode: currentFacingMode,
      // deviceId: {
      //   exact: videoDevices[selectedCamera].deviceId
      // }
    }
  };
  console.log(updatedConstraints)
  navigator.mediaDevices.getUserMedia(updatedConstraints).
  then((stream) => {video.srcObject = stream});
};

photoButton.onclick = video.onclick = function() {
  imgContainer.id = "contracted";
  video.pause();

  canvas.width = video.videoWidth;
  canvas.height = video.videoHeight;
  ctx.drawImage(video, 0, 0);

  ga('send', {
    hitType: 'event',
    eventCategory: 'Photo',
    eventAction: 'take picture',
    eventLabel: 'Reddit Campaign'
  });

  flipButton.hidden = true;
  photoButton.hidden = true;
  deleteButton.hidden = false;
  saveButton.hidden = false;
  idField.hidden = false;

  Promise.all(
    imgContainer.getAnimations().map(
      function(animation) {
        return animation.finished
      }
    )
  ).then(
    function() {
      video.hidden = true;
      canvas.hidden = false;
    }
  );




};

deleteButton.onclick = function() {
  imgContainer.id = "expanded";
  video.play()
  video.hidden = false;
  canvas.hidden = true;
  flipButton.hidden = false;
  photoButton.hidden = false;
  deleteButton.hidden = true;
  saveButton.hidden = true;
  idField.hidden = true;
  rect = null;
  pos = null;
  topLeft = null;
  topRight = null;
  bottomLeft = null;
  bottomRight = null;
  ga('send', {
    hitType: 'event',
    eventCategory: 'Photo',
    eventAction: 'delete picture',
    eventLabel: 'Reddit Campaign'
  });
}

saveButton.onclick = function() {
  video.play()
  video.hidden = false;
  canvas.hidden = true;
  flipButton.hidden = false;
  photoButton.hidden = false;
  deleteButton.hidden = true;
  saveButton.hidden = true;

  let dateTime = getDateTimeSting()

  ctx.clearRect(0, 0, canvas.width, canvas.height);
  ctx.drawImage(video, 0, 0);
  canvas.toBlob(function (blob) {
    saveAs(blob, "bboxr_" + objectId.value + dateTime + ".png");
    ga('send', {
      hitType: 'event',
      eventCategory: 'Photo',
      eventAction: 'save picture',
      eventLabel: 'Reddit Campaign'
    });
  });

  if (!(Object.keys(rect).length === 0 && rect.constructor === Object)) {
    let annotation = {
      object: {
        name: objectId.value,
        pose: "Unspecified",
        truncated: 0,
        difficult: 0,
        bndbox: {
          xmin: Math.round(Math.min(rect.startX, rect.startX + rect.w)),
          ymin: Math.round(Math.min(rect.startY, rect.startY + rect.h)),
          xmax: Math.round(Math.max(rect.startX, rect.startX + rect.w)),
          ymax: Math.round(Math.max(rect.startY, rect.startY + rect.h)),
        }
      }
    }
    let annotationBlob = new Blob(
      //[JSON.stringify(annotation)],
      [OBJtoXML(annotation)],
      {type: 'text/plain'});
    saveAs(annotationBlob, "bboxr_" + objectId.value + dateTime + ".xml");
    ga('send', {
      hitType: 'event',
      eventCategory: 'Annotation',
      eventAction: 'save annotation',
      eventLabel: 'Reddit Campaign'
    });
  }

  rect = {};

  draw();
}
